import { axiosYtApiV2 } from "@/services/axios-yt-api-v2";

export const axiosSearchhelper = {
  async getDatepicker() {
    const { data } = await axiosYtApiV2.get('/searchhelper/datepicker');
    return data;
  }
}
